import React, {useState} from 'react';

import { Row, Col, Card, Button, Table } from 'antd';
import CreateSurveyModalView from 'components/module/CreateSurveyModal';
import { SurveyType } from 'models/Survey';

import { SurveyGeneratedProps } from './Survey.props';
import { Container, StyledSpace } from './Survey.style';
import { Column } from './Survey.props';

const columns: Column[] = [
  { title: 'Survey Title', dataIndex: 'title' },
  { title: 'Used', dataIndex: 'used' },
];

const SurveyView = (props: SurveyGeneratedProps): JSX.Element => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [survey, setSurvey] = useState<SurveyType>();

  return (
    <Container>
      <StyledSpace direction="vertical" size={16}>
        <Row justify="end">
          <Button type="primary" onClick={props.onClickCreate}>
            Create Survey
          </Button>
        </Row>

        <Table
          // columns={columns}
          dataSource={props.data}
          // onChange={props.onChange}
          loading={props.loading}
          rowKey="id"
        >
          {columns.map((col) => (
            <Table.Column key={col.dataIndex} {...col} />
          ))}

          {
            <Table.Column
            title={'Actions'}
            render={(e) => (
              <Button
                type="primary"
                onClick={() => {
                  setShowEditModal(true);
                  setSurvey(e);
                }}
              >
                Edit Survey
              </Button>
            )}
            />
          }
        </Table>
      </StyledSpace>

      { showEditModal && (
        <CreateSurveyModalView
          loading={false}
          initialValues={survey}
          onSubmit={() => {
            // TODO
          }}
        />
      )}
    </Container>
  );
};

export default SurveyView;
